export default __webpack_public_path__ + "static/media/content_01_bg.094869ba.jpg";